import gql from 'graphql-tag';

export const FETCH_ANNOUNCEMENTS_QUERY = gql`
  {
    fetchAnnouncements {
      _id
      customMessage
      createdAt {
        timestamp
      }
      sender {
        first
        last
      }
    }
  }
`;

export const SEND_ANNOUNCEMENT_MUTATION = gql`
  mutation sendAnnouncement($organizations: [ID]!, $universities: [ID!]!, $tutors: Boolean!, $students: Boolean!, $notification: NotificationLocalesInput!) {
    sendAnnouncement(organizations: $organizations, universities: $universities, tutors: $tutors, students: $students, notification: $notification)
  }
`;



// WEBPACK FOOTER //
// ./src/modules/announcement/api.js